module.exports = __webpack_public_path__ + "static/media/solicitar-consulta.08b3656d.svg";